import React, { FC } from "react";

import Header from "../organisms/Layout/Header";
import Image from "../atoms/Image";
import image from "../../images/undraw_security_o890.svg";
import Label from "../atoms/Label";
import { useTitle } from "../../hooks/useTitle";

const Page403: FC = () => {
  useTitle().setTitle("アクセスする権限がありませんでした。(403:Forbidden)");

  return (
    <div className="flex flex-col w-screen h-screen bg-gray-background">
      <Header />
      <div className="flex flex-col flex-grow items-center justify-center">
        <Image src={image} width="290px" height="240px" />
        <Label className="font-bold">
          アクセスする権限がありませんでした。
        </Label>
        <Label>アクセスされたURLにアクセスする権限がありませんでした。</Label>
        <Label>
          URLを確認するかタブ・ウィンドウを閉じてログインからやり直してください。
        </Label>
      </div>
    </div>
  );
};

export default Page403;
